import React, { useState } from "react"
import { Skeleton, Typography, MenuItem, CardHeader, Card, CardContent, CardMedia } from '@mui/material'
import MenuBar from '../../ui/menuBar/MenuBar'
import SparklineGraph from "../../Graphs/SparklineGraph"
import { marginToPaddingStyles } from '../../Graphs/graphUtils'
import dashboardStyles from '../../../pages/Dashboard.module.scss'
import { formatPrice, formatPercent } from '../../../utils/tools'
import useProject from "../hooks/useProject"
import { useGeneral } from "../../../context/general"
import './Project.css'
import axios from "axios"

const graphMargin = {top: 16, bottom: 16, right: 16, left: 8}
const skeletonPadding = marginToPaddingStyles(graphMargin)

// export default function Project({ ticker, name, uuid, updated_at,currency_code, handleCreateProjectAndOpen }) {
export default function Handler({ ticker, name, uuid, updated_at,currency_code, handleCreateProjectAndOpen }) {
    const [anchorEl, setAnchorEl] = useState(null)
    const { sparkline } = useProject(ticker)
    const { projectMethods, setWatchlistData } = useGeneral()
    
    const onClick = () => {
        handleCreateProjectAndOpen(ticker)
    }

    const handleWatchlistProject = async (e) => {
        e.stopPropagation()
        // projectMethods.toggleWatchlist(uuid)
        setAnchorEl(null)
        // const resJson = await fetch('/api/removefromWatchlist', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({'ticker':ticker})
        // })
        const resJson = await axios({
            method: 'POST',
            url: '/api/removefromWatchlist',
            data: {'ticker':ticker}
        })
        const res = await resJson.data
        Array.isArray(res) && setWatchlistData(res)
    }

    const menuItems = () => {
        return [
            <MenuItem key={`watchlist-${uuid}`} onClick={handleWatchlistProject}>
                Remove From Watchlist
            </MenuItem>
        ]
    }

    return (
        <Card className={`projectCard ${dashboardStyles['card']}`} onClick={onClick} >
            <CardHeader
                className="projectCard-header"
                action={
                    <MenuBar setAnchorEl={setAnchorEl} anchorEl={anchorEl} menuId={`project-options-${name}`}>
                         {menuItems()}
                    </MenuBar>
                }
            />
            <CardContent className="projectCard-content">
                <div>
                    <Typography variant="overline" className="projectCard--light">
                        {updated_at.length>0&&new Date(updated_at[0]).toLocaleDateString()}
                    </Typography>
                    <Typography variant="h3">
                            {ticker}
                    </Typography>
                </div>
                <div className="projectCard-numbers">
                    <Typography variant="h2" className="projectCard-price" >
                        {sparkline?.lastPrice
                            ? new Intl.NumberFormat('en-US', { style: 'currency', currency: currency_code }).format(sparkline.lastPrice)
                            : <Skeleton variant="text" width="3em" />
                        }
                    </Typography>
                    <Typography className={`projectCard-price ${sparkline?.diffPrecent < 0 ? 'down' : 'up'}`}>
                    {sparkline
                        ? `${formatPrice(sparkline.diff,'always','en-US',currency_code)}
                        (${formatPercent(sparkline.diffPrecent)})`
                        : <Skeleton variant="text" width="5em" />
                    }
                    </Typography>
                </div>
            </CardContent>
            <CardMedia className="projectCard-graph">
                {sparkline?.data
                    ? <SparklineGraph graph={[sparkline]} margin={graphMargin} />
                    : <div style={skeletonPadding}>
                        <Skeleton variant="rect" width="100%" height="100%" />
                    </div>
                }
            </CardMedia>
        </Card>
    )
}